module.exports = __webpack_public_path__ + "static/img/border2_bg.5a1948ce.png";